import React from "react";
import GitHubImg from "./GitHub.png";
import LinkedInImg from "./LinkedIn.png";
import "./Connect.css";

const Connect = () => (
  <div className="ConnectMain">

	<h3 className="text-center">Connect With Me</h3>
    <hr/>
    <a className="ConnectLogo" href={"https://github.com/charlesroberts442/"} target={"_blank"}><img src={GitHubImg} height="40px" alt="Github"/> </a>
    <a className="ConnectLogo" href={"https://www.linkedin.com/in/charles-roberts-bee-mscs"} target={"_blank"}><img src={LinkedInImg} height="40px" alt="LinkedIn"/> </a>

    </div>

	
);

export default Connect;


// WEBPACK FOOTER //
// ./src/components/Connect/Connect.js